import getFormattedTime from '@helpers/getFormattedTime'
import getCurrentDateObj from '@helpers/getCurrentDateObj'
import getFormattedDotDate from '@apps/order-form/src/helpers/getFormattedDotDate'
import services from './services'

export default {
  ...services,

  isApp: ({ additional }) => additional?.isApp || false,

  formIsLoading: state => state.isFormLoading,

  orderDots: state => state.order.dots,

  isBuyout({ additional, base, form }) {
    const isEditBuyout = base.isEdit && form.deliveryObject.info.isBuyout
    const isFormWithBuyout = [2, 4].indexOf(additional.formVersion) !== -1

    return isEditBuyout || isFormWithBuyout
  },

  isAnonimousForm({ additional }) {
    return [3, 4].indexOf(additional.formVersion) !== -1
  },

  user(state) {
    return state.selectedUser || state.user
  },

  isAdmin(state) {
    return state?.base?.isAdmin || false
  },

  isCashOnDelivery({ order }) {
    return !!order.dots.find(dot => dot.cash == 1)
  },
  isDeliveryExtraPay({ order }) {
    return !!order.dots.find(dot => dot.deliveryExtraPay !== 0)
  },
  isOrderButtonBlocked(state) {
    return state.isOrderButtonBlocked
  },

  selectedCity({ form, order }) {
    return form.allCities.find(city => city.id == order.city) || form.allCities[0]
  },

  selectedLocations(state, getters) {
    const regions = getters.selectedCity.regions.map(region => ({
      region,
    }))

    return regions
  },

  // Размер окна
  formSize({ formWidth }) {
    // Компьютера
    if (formWidth > 992) {
      return 2
    }

    // Планшета
    if (formWidth > 425) {
      return 1
    }

    // Смартфона
    return 0
  },

  totalPrice({ advanceCheque }) {
    const totalPrice = advanceCheque.find(row => row.name === 'Итого доставка')

    return totalPrice ? totalPrice.value : 0
  },

  refundableAmount({ advanceCheque }) {
    const refundableAmount = advanceCheque.find(el => el.name === 'Сумма к возврату')

    return refundableAmount ? refundableAmount.value : 0
  },

  promoDiscount({ advanceCheque }) {
    const promoDiscount = advanceCheque.find(row => row.name === 'Скидка по промо-коду')

    return promoDiscount ? promoDiscount.value : 0
  },

  isFarFromMetro({ order }) {
    return order.dots.find(dot => dot.distanceFromMetro >= 25000)
  },

  advanceCheque(state) {
    return state.advanceCheque
  },

  isExceededBuyoutCost: (state, getters) =>
    getters.isBuyout && getters.totalItemsPrice > state.form.maxItemsSumCost,

  totalItemsWeight: state => {
    if (state.order.dots.length > 1) {
      return state.order.dots
        .reduce((prev, curr) => [...prev, ...curr.items], [])
        .reduce((prev, curr) => prev + curr.weight * curr.count, 0)
    }

    return 0
  },

  totalItemsPrice: state => {
    if (state.order.dots.length > 1) {
      return state.order.dots
        .reduce((prev, curr) => [...prev, ...curr.items], [])
        .reduce((prev, curr) => prev + curr.price * curr.count, 0)
    }

    return 0
  },

  totalItemsPriceWithRefund: state => {
    if (state.order.dots.length > 1) {
      return state.order.dots
        .reduce((prev, curr) => (curr.cash ? [...prev, ...curr.items] : [...prev]), [])
        .reduce((prev, curr) => prev + curr.price * curr.count, 0)
    }

    return 0
  },

  maxItemsCost: (state, getters) =>
    getters.isBuyout ? state.form.orderBuyoutLimit : state.form.maxItemsSumCost,
  maxItemCost: (state, getters) =>
    getters.isBuyout ? state.form.orderBuyoutLimit : state.form.maxItemCost,
  minItemsSumCost: (state, getters) => (getters.isBuyout ? 1 : state.form?.minItemsSumCost || 100),
  maxWeight() {
    return 1500000
  },

  availableWeightValues: state => {
    const returnValues = (min = 0, max = Infinity) =>
      state.weightValues.filter(val => val >= min && val <= max)

    switch (state.order.deliveryMethod) {
      case 0: {
        return returnValues(0, 15000)
      }

      case 1: {
        return returnValues(0, 100000)
      }

      case 2: {
        return returnValues(0, 300000)
      }

      default:
        return state.weightValues
    }
  },

  drafts({ form }) {
    return form.orderDraft.filter(draft => draft.is_suggestion)
  },

  templates({ form }) {
    return [
      ...form.orderTemplates,
      ...form.orderDraft.filter(draft => !draft.is_suggestion && !draft.is_addressBookItem),
    ]
  },
  isCapitalsSelected(state, getters) {
    const capitals = [1, 2]

    return capitals.includes(getters.selectedCity.id)
  },
  canYandexOrderCreate(state) {
    return state.base.canYandexOrderCreate
  },
  isYandexForm(state, getters) {
    return getters.canYandexOrderCreate && !getters.isCapitalsSelected && !getters.isBuyout
  },
  isCrmCourierChosen(state) {
    return !!state.chosenCrmCourier
  },

  dotsCoordinates({ order }) {
    return order.dots.filter(dot => dot.lat && dot.lng).map(dot => [dot.lat, dot.lng])
  },

  /**
   * Добавление 30 минут к текущему времени, мнимальным селектом будет слеующее значение за текущим временем
   *
   * 12:10 + 30 = 12:40 -> 13:00
   * 12:30 + 30 = 13:00 -> 13:30
   */
  minTimePickup({ currentDate }) {
    const currentDateWithOffset = new Date(currentDate.date)

    currentDateWithOffset.setMinutes(currentDateWithOffset.getMinutes() + 30)

    return getFormattedTime(currentDateWithOffset)
  },

  /**
   * Для случая модернизации логики для точек доставки
   */
  minTimeDelivery: (_, { minTimePickup }) => minTimePickup,

  getDotIndex:
    ({ order }) =>
    dot =>
      order.dots.indexOf(dot),

  // Форматируем использованное время в заказе для отправки
  formattedDates({ order, form }) {
    return order.dots.map((dot, index) => {
      const formattedDates = []
      //
      const { date: dotDate } = dot
      const { timeFrom } = dot
      let { timeTo } = dot
      //
      const dotDateObj = new Date(dotDate)
      const year = dotDateObj.getFullYear()
      const month = dotDateObj.getMonth() + 1
      const day = dotDateObj.getDate()

      const isDataNotCompletable =
        !dotDate ||
        !timeFrom ||
        !timeTo ||
        !year === undefined ||
        Number.isNaN(month) ||
        Number.isNaN(day)

      if (isDataNotCompletable) return null

      // TimeFrom
      const timeFromDateObj = new Date(dotDate)
      const [timeFromHours, timeFromMinutes] = timeFrom.split(':')

      timeFromDateObj.setHours(timeFromHours)
      timeFromDateObj.setMinutes(timeFromMinutes)

      formattedDates.push(getFormattedDotDate(timeFromDateObj))

      // Для точки доставки отдельный перерасчет
      const allDots = order.dots
      // Функция проверки на то, что "до" в этой точке == "неважно"
      const isNoMatter = (time = timeTo) => time === '23:59'

      // Функция получения списка времен в этот день
      const getOtherDotsInSameDay = targetDot =>
        allDots
          .map((_dot, _index) => {
            if (index < _index && targetDot.date === _dot.date) {
              return _dot
            }

            return null
          })
          .filter(Boolean)

      // Если в этой точке "до" "неважно" — изменяем ее
      if (isNoMatter()) {
        let maxTime = '22:00'
        let isFindExactTime = false
        const othersDots = getOtherDotsInSameDay(dot)

        // Получаем все последующие точки с "неважно", до первой "важно"
        const conditedDots = othersDots
          .map(_dot => {
            if (isFindExactTime) return null

            // Если такую встретили — записываем время и выходим
            if (!isNoMatter(_dot.timeTo)) {
              isFindExactTime = true
              maxTime = _dot.timeTo
              return null
            }

            return _dot.timeTo
          })
          .filter(_dot => !!_dot)

        // Получаем список доступных времен по максимальномо доступному времени
        const times = form.allTimes.filter(time => time.value < maxTime)

        // Считаем количество впереди стоящих точек с "неважно", и подставляем конкретное значение нашей
        timeTo = times[times.length - (1 + conditedDots.length)].value
      }

      const timeToDateObj = new Date(dotDate)
      const [timeToHours, timeToMinutes] = timeTo.split(':')

      timeToDateObj.setHours(timeToHours)
      timeToDateObj.setMinutes(timeToMinutes)

      formattedDates.push(getFormattedDotDate(timeToDateObj))

      return formattedDates
    })
  },

  buildedOrder(state, getters) {
    const { order, base, additional } = state
    const { user } = getters
    const { isBuyout } = getters

    const selectedCouriers = user.favoriteCouriers
      ? user.favoriteCouriers.filter(courier => courier.selected)
      : []

    const promocode = order.promocode.validCode == 0 ? order.promocode.value : ''

    // Очищаем поля от приписок, прежде чем отправить на бэк
    const removePostscripts = (value, name) => {
      if (value) {
        switch (name) {
          case 'storey':
            if (value.startsWith(state.postscripts.storey)) {
              value = value.slice(3, value.length)
            }

            return value
          case 'apartment':
            if (value.startsWith(state.postscripts.apartment)) {
              value = value.slice(3, value.length)
            }

            return value
          case 'entrance':
            if (value.startsWith(state.postscripts.entrance)) {
              value = value.slice(4, value.length)
            }

            return value
        }
      }
    }

    const selectedCard = order.paymentMethod === 5 && order.selectedCard ? order.selectedCard : null

    const Order = {
      orderId: order.id,
      orderInitStatus: order.initStatus,
      Order: {
        formVersion: additional.formVersion,
        user: user.id,
        fix_tariff_on_edit: +(base.isAdmin && state.fixPriceStatus == 1),
        fix_next_day_price: +(base.isAdmin && state.fixPriceStatus == 2),
        favorite_couriers: selectedCouriers.length
          ? JSON.stringify(selectedCouriers.map(courier => courier.cid))
          : '',
        favorite_enable: +!!selectedCouriers.length,
        type_pay: order.paymentMethod,
        manual_narrow_interval: Number(state.manualNarrowInterval),
        manual_other_day: Number(state.manualOtherDay),
        isPublic: 0,
        type: 0,
        with_buyout: +isBuyout,
        pack: '',
        ewalletType: order.incomeReturnMethod,
        ewallet: order.wallet,
        shop_name: order.shop.name,
        shop_inner_id: order.shop.orderInnerId,
        promo_code: promocode,
        comment: 'Заказ',
        courier_addition: +order.shop.surcharge,
        servicesArray: getters.addedServicesID,
        template_id: state.selectedTemplate ? state.selectedTemplate.tid : null,
        createdViaApp: +!!additional.isApp,
        bank_card_id: selectedCard ? selectedCard.id : null,
        bank_card_type: selectedCard ? selectedCard.type : null,
        id_type_auto: order.deliveryMethod,
        is_for_yandex: getters.isYandexForm ? 1 : 0,
        time_due: state.isSendTimeDue ? getters.formattedDates[0][0] : null,
        crm_courier: state.chosenCrmCourier,
      },
      Dots: order.dots.map((dot, ind) => ({
        cheque_created: dot.chequeCreated,
        cheque_created: 0,
        current_id: dot.id ? dot.id : null,
        cash: dot.cash || +isBuyout,
        city_id: order.city,
        address_city: dot.suburb || getters.selectedCity.name,
        prigorod: +dot.isSuburb || 0,
        distance_from_metro: +dot.distanceFromMetro || 0,
        address_street: dot.street || dot.address,
        address_building: dot.building,
        address_storey: removePostscripts(dot.storey, 'storey'),
        address_entrance: removePostscripts(dot.entrance, 'entrance'),
        address_apartments: removePostscripts(dot.apartment, 'apartment'),
        lat: dot.lat,
        lng: dot.lng,
        is_metro: dot.isMetro,
        metro_id: dot.metroId,
        metro_not_found: +dot.isMetroNotFound,
        right_formatted_address: dot.input,
        address_region: dot.region,
        target: dot.comment,
        phone: isBuyout && ind === 0 && dot.phone == '' ? '+7(812)748-26-37' : `+7${dot.phone}`,
        name: dot.contact
          ? dot.contact
          : ind === 0
          ? 'Отправитель'
          : `Получатель${state.order.dots.length > 2 ? ` №${ind}` : ''}`,
        dateFrom: getters.formattedDates[ind][0],
        dateTo: getters.formattedDates[ind][1],
        return_dot: +(order.dots.indexOf(dot) == 0),
        shop_delivery: isBuyout ? 0 : dot.deliveryExtraPay,
        items: dot.items.map(item => ({
          name: item.name,
          weight:
            item.weight == '' || !Number.isInteger(Math.round(item.weight))
              ? ''
              : Math.round(item.weight),
          quant:
            item.count == '' || !Number.isInteger(Math.round(item.count))
              ? ''
              : Math.round(item.count),
          price:
            item.price == '' || !Number.isInteger(Math.round(item.price))
              ? ''
              : Math.round(item.price),
        })),
      })),
    }

    return Order
  },
}
